import styled from '@emotion/styled'
import {theme} from '../../../core/theme/theme'

export const PageWrapper = styled.section`
  display: flex;
  flex-direction: column;
  min-height: 100%;
  width: 100%;
  // transparent so the app-wide AppBackground (app-shell) shows through
  background: transparent;
  padding: 10px;
  gap: 8px;
`

export const PageHeader = styled.div`
  background: ${theme.palette.neutral[0]}
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  // gap: ${theme.space[1]};
`

export const PageTitle = styled.h1`
  font-size: ${theme.fontSizes['3xl']};
  font-weight: ${theme.fontWeights.bold};
  color: ${theme.colors.text.primary};
  margin: 0 0 ${theme.space[1]};
`

export const ContentArea = styled.main`
  // flex: 1;
  // display: flex;
  // justify-content: center;
  //   flex-direction: column;
  //   align-items: center;
  // padding: ${theme.space[2]};
  width: 100%;
  // // background: #f4f6fb;
`
